/** Heading levels an editor can pick for a widget title (`titlePower` in Strapi). */
export type HeadingLevel = '2' | '3' | '4' | '5';

export type HeadingTagName = 'h2' | 'h3' | 'h4' | 'h5' | 'p';

/**
 * The element a widget title renders as (70.15-Heading-Structure): `<hN>`, or
 * `<p class="hN">` when the editor ticked "Nur optisch". The look-alike class
 * comes from `globals.css`, so both render identically and only the document
 * outline differs.
 */
export function headingTag(
  level: HeadingLevel,
  visualOnly?: boolean | null,
): { as: HeadingTagName; className?: string } {
  return visualOnly ? { as: 'p', className: `h${level}` } : { as: `h${level}` };
}
